var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-gray-900 hover:bg-gray-100 border border-solid border-gray-200 px-7px md:px-2 py-1 mr-2 rounded-full cursor-pointer ds-text-sm md:ds-text-base",attrs:{"data-test-id":"toggle-cta"},on:{"click":_vm.close}},[_c('Icon',{ref:"icon",attrs:{"name":"chevron-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }